/** Shared In Play / Market list row display — Lab market list shape. */

import { marketStatusLabel } from './resultVendorIds'

export function marketListMarketId(row: Record<string, unknown>): string {
  const id = String(row.marketId ?? row.betfairId ?? row.id ?? '').trim()
  return id || '—'
}

export function marketListName(row: Record<string, unknown>): string {
  return String(row.name ?? row.marketName ?? '—') || '—'
}

export function marketListEventName(row: Record<string, unknown>): string {
  const ev = row.event
  if (ev && typeof ev === 'object' && !Array.isArray(ev)) {
    const name = String((ev as { name?: unknown }).name ?? '').trim()
    if (name) return name
  }
  const flat = String(row.eventName ?? '').trim()
  if (flat) return flat
  if (typeof ev === 'string' && ev.trim()) return ev.trim()
  return '—'
}

export function marketListGame(row: Record<string, unknown>): string {
  return String(row.gameValue ?? row.sportName ?? row.game ?? '—') || '—'
}

/**
 * In Play / List STATUS column.
 * CM Market Selection "enable" rewrites trading `status` to OPEN but leaves
 * `isResult` set after declare — prefer settle label (same as Markets View).
 */
export function marketListStatus(row: Record<string, unknown>): string {
  const status = row.status ?? row.enable
  const isResult = Boolean(row.isResult)
  if (status == null && !isResult) return '—'
  return marketStatusLabel({
    status: status != null ? String(status) : null,
    isResult,
    result: row.result != null ? String(row.result) : null,
  })
}

export function marketListRowKey(row: Record<string, unknown>): string {
  return String(row._id ?? row.betfairId ?? row.id ?? row.marketId ?? '')
}

export function marketListEditId(row: Record<string, unknown>): string {
  return String(row._id ?? row.betfairId ?? row.id ?? '').trim()
}
